import React from "react";
import LessonData from "../LessonData";
import LessonCartaPreview from "./lessons/LessonCartaPreview";
import { LessonResourcesDownload } from "../lessons/LessonResourcesDownload";

const LessonPreviewMiddleware = ({ lessonType, data, seed, state = {} }) => {
  const type = Object.keys(seed || {})[0] || undefined;
  if(type === 'LESSON_RESOURCES_DOWNLOAD'){
    const data = seed['LESSON_RESOURCES_DOWNLOAD'];
    return (
      <div className="w-full">
        <LessonResourcesDownload description={data?.description} resources={data?.data} />
      </div>
    );
  }
  if (lessonType === "LESSON_CARTA")
    return <LessonCartaPreview description={data?.description} />;
  else return <LessonData seed={seed} />;
};

export default LessonPreviewMiddleware;
